import React, { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import {
  Card,
  CardTitle,
  Row,
  Col,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import {PopUp,
PopUpSuccess,
} from "../../../components/adminSettings/index";
import {
  getQualification,
  addEmpEducationalInfo,
  updateEmpEducationalInfo,
  delEmpEducationalInfo,
  getEmpPreviousCompanyInfo,
  addPreviousCompanyInfo,
  updatePreviousCompanyInfo,
  delPreviousCompanyInfo,
  updateEmp,
  getEmpEducationalInfo,
  getShifts,
} from "../../../redux/actions/employee/employee.action";
import Moment from 'moment';
import Notifications from "../../../components/common/Notifications";
// style for the edit/update forms.
const fontSize = {
  fontSize: "12px",
};
const inputHeight = { height: "35px" };
const TabProfile = React.memo((props) => {
  const [employeeDetails, setEmployeeDetails] = useState({});

  const {
    selectEmp,
    addEmpEducationalInfo,
    getQualification,
    updateEmpEducationalInfo,
    delEmpEducationalInfo,
    getEmpPreviousCompanyInfo,
    addPreviousCompanyInfo,
    updatePreviousCompanyInfo,
    delPreviousCompanyInfo,
    getEmpEducationalInfo,
    getShifts
  } = props;
  const { qualification, prevcompanyinfo,shifts } = props.empeducationalInfo;

  const [isClickEdit, setIsClickEdit] = useState("");
  const [
    popoverOpenAddEducationalInfo,
    setpopoverOpenAddEducationalInfo,
  ] = useState(false);

  const [qualificationName, setQualificationName] = useState("");
  const [branch, setBranch] = useState("");
  const [university, setUniversity] = useState("");
  const [yop, setyop] = useState("");
  const [typeofstudy, setTypeofstudy] = useState("");
  const [gpa, setgpa] = useState("");
  const [qualificationId, setQualificationId] = useState("");
  const [shiftId, setShiftId] = useState("");
  const [eduQualificationId, setEduQualificationId] = useState(0);

  const [role, setRole] = useState("");
  const [duration, setDuration] = useState("");
  const [company, setCompany] = useState("");
  const [designation, setDesignation] = useState("");
  const [durationFrom, setFrom] = useState("");
  const [durationTo, setTo] = useState("");
  const [employeeCompanyDetailsId, setEmployeeCompanyDetailsId] = useState(0);
  const [isopenpopup,setisopenpopup]=useState(false);
  const [isopenpopupSuccess,setisopenpopupSuccess]=useState(false);
  const [curDelId,setcurDelId] =useState(0);
  const [curTypeId,setcurTypeId] =useState(0);
  const [error, setError] = useState(null);
  const [employeeId,setemployeeId] =useState("");
  const [prevcompanyDetails,setprevcompanyDetails] =useState([]);
  const [educationinformation,seteducationinformation] =useState([]);
 
  // ========== Function's.
  var loginUser = JSON.parse(localStorage.getItem("user"));
  let empId = loginUser.EmployeeId;
  useEffect(() => {    
    getQualification();
    getEmpEducationalInfo(props.employeeId);
    getEmpPreviousCompanyInfo(props.employeeId);
    getShifts();
    setprevcompanyDetails(props.empeducationalInfo.prevcompanyinfo);
  }, [setprevcompanyDetails]);

  useEffect(() => {
    getEmpPreviousCompanyInfo(props.employeeId);
    setprevcompanyDetails(props.empeducationalInfo.prevcompanyinfo);
  });

  useEffect(() => {
    getEmpEducationalInfo(props.employeeId);
    getEmpPreviousCompanyInfo(props.employeeId);
  }, [getEmpEducationalInfo,getEmpPreviousCompanyInfo]);

  useEffect(() => {
    //console.log("EmployeeDetails",selectEmp);
    // seting the value of selected employee to state
    selectEmp.value !== undefined &&
      setEmployeeDetails({
        ...selectEmp.value,
        /*isActive: true,
        password: "hellothere",
        roles: "string",
        fileName: "string",
        contentType: "string",
        file: null,
        isLatest: true,
        encrptedPassword: "string",*/
      });
  }, [selectEmp]);

  const toggle = () =>
    setpopoverOpenAddEducationalInfo(!popoverOpenAddEducationalInfo);
  const maskAadhar = (aadhar) => {
   if(aadhar != undefined)
    { 
     return aadhar.replace(/.(?=.{4})/g, '*') ;
    }
  }
  const handleClickEdit = React.useCallback(
    (whichCard) => {
      setIsClickEdit(whichCard);
    },
    [setIsClickEdit]
  );

  const handleAddClickEduInfo = React.useCallback((e) => {
    e.preventDefault();
    let qName = "";
    qualification.map((el) =>
      parseInt(el.qualificationId) === parseInt(qualificationId)
        ? (qName = el.qualificationName)
        : null
    );
    let formData = {
      qualificationName: qName,
      branch: branch,
      universityName: university,
      yearOfPassing: parseInt(yop),
      studyType: typeofstudy,
      percentageOrGPA: gpa,
      qualificationId: parseInt(qualificationId),
      employeeId: parseInt(props.employeeId),
      educationalQualificationId: parseInt(eduQualificationId),
    };
    if(qName === '')
    {
      setError({ ...error, message: "Enter Any Details..", status: 500 });
    }
    else
    {
      eduQualificationId !== 0
      ? updateEmpEducationalInfo(formData)
      : addEmpEducationalInfo(formData);
      if(eduQualificationId !== 0)
      {
        setError({ ...error, message: "Education Updated..", status: 200 });
      }
      else
      {
        setError({ ...error, message: "Education Added..", status: 200 });
      }
      getEmpEducationalInfo(parseInt(empId));
      setTimeout(() => { 
        window.location.reload();

    }, 3000);
    }
    
    handleClickEdit("");
  },[branch,university,yop,typeofstudy,gpa,qualificationId,empId,eduQualificationId,getEmpEducationalInfo]);

  const handleAddClickCompanyInfo =React.useCallback((e) => {
    e.preventDefault();
   
    if (!company || !designation || !duration || !durationFrom || !durationTo) {
      alert("Please fill in all required fields.");
      return;
    }

    let formData = {
      employeeCompanyDetailsId: parseInt(employeeCompanyDetailsId),
      companyName: company,
      designation: designation,
      durationOfWork: parseFloat(duration),
      employeeId: parseInt(props.employeeId),
      fromDate: durationFrom,
      toDate: durationTo,
    };
    
    employeeCompanyDetailsId !== 0
      ? updatePreviousCompanyInfo(formData)
      : addPreviousCompanyInfo(formData);
      employeeCompanyDetailsId !== 0 ? ( setError({ ...error, message: "Experience updated successfully...", status: 200 }))
      :(setError({ ...error, message: "Experience added successfully...", status: 200 }))
    handleClickEdit("");
    getEmpPreviousCompanyInfo(props.employeeId);
    setprevcompanyDetails(prevcompanyinfo);
    
 
  
  },[employeeCompanyDetailsId,company,designation,duration,durationFrom,durationTo,getEmpPreviousCompanyInfo,props,prevcompanyinfo]);

  const handleClickUpdateCompanyInfo = (e) => {
    //console.log(e);
    setEmployeeCompanyDetailsId(e.employeeCompanyDetailsId);
    setCompany(e.companyName);
    setDesignation(e.designation);
    setDuration(e.durationOfWork);
    setFrom(Moment(e.fromDate).format("YYYY-MM-DD"));
    setTo(Moment(e.toDate).format("YYYY-MM-DD"));
    handleClickEdit("workExperience");
  };

  const handleClickUpdateEduInfo = (e) => {
    setEduQualificationId(e.educationalQualificationId);
    setBranch(e.branch);
    setQualificationName(e.qualificationName);
    setUniversity(e.universityName);
    setTypeofstudy(e.studyType);
    setgpa(e.percentageOrGPA);
    setyop(e.yearOfPassing);
    setQualificationId(e.qualificationId);
    setShiftId(e.shiftId);
    handleClickEdit("eduInformation");
  };

  const handleClearValues = (cardname) => {
    if (cardname === "eduInformation") {
      setEduQualificationId(0);
      setBranch("");
      setQualificationName("");
      setUniversity("");
      setTypeofstudy("");
      setgpa("");
      setyop("");
      handleClickEdit("eduInformation");
    } else if (cardname === "workExperience") {
      setEmployeeCompanyDetailsId(0);
      setCompany("");
      setDesignation("");
      setDuration("");
      setFrom("");
      setTo("");
      handleClickEdit("workExperience");
    }
  };

  const handleClickDeleteInfo = (detailsId,employeeId,typeid) => {
    setisopenpopup((prevState) => !prevState);
    setcurTypeId(typeid);
      setcurDelId(detailsId);
      setemployeeId(employeeId);
  };
  const hadleDelWithPopYes =React.useCallback(() =>{
    // const res= delOfficeLoation(curDelId);
    if(curTypeId == 1)
      {
        delEmpEducationalInfo(parseInt(curDelId),parseInt(employeeId));
      }
      else{
        delPreviousCompanyInfo(parseInt(curDelId));
      }
   
    setisopenpopup((prevState) => !prevState);
    setisopenpopupSuccess((prevState) => !prevState);
  
    }, [delEmpEducationalInfo,curDelId,employeeId,curTypeId,delPreviousCompanyInfo]);

  const hadleDelWithPopNo =React.useCallback(() =>{
   setisopenpopup((prevState) => !prevState);
  
  });
    
 const hadleSuccessPop =React.useCallback(() =>{
   setisopenpopupSuccess((prevState) => !prevState);
   setError({ ...error, message: "Experience deleted successfully...", status: 200 })
  
  });
  const handleClickDeleteCompanyInfo = (employeeCompanyDetailsId) => {
    delPreviousCompanyInfo(employeeCompanyDetailsId);
  };

  // personal information on update -> state change function.
  const handleOnChangePersonalInfoFields = React.useCallback(
    (field, value) => {
      let updateObj = employeeDetails;

      let updateValue = {
        ...updateObj,
        [field]: value,
      };
      setEmployeeDetails(updateValue);
      //console.log(updateValue);
    },
    [employeeDetails]
  );

  // on update click of personal infomation
  const handleUpdatePersonalInfo = React.useCallback(() => {
    let empFormData = new FormData();
    for ( var key in employeeDetails ) {
      empFormData.append(key, employeeDetails[key]);
  }
//   if((employeeDetails.ifscCode === 'null' || employeeDetails.ifscCode === '' || employeeDetails.ifscCode === null) & (employeeDetails.bankAccountNumber === 'null' || employeeDetails.bankAccountNumber === '' || employeeDetails.bankAccountNumber === null) && (employeeDetails.aadharNumber === 'null' || employeeDetails.aadharNumber === '' || employeeDetails.aadharNumber === null) && (employeeDetails.panNumber === 'null' || employeeDetails.panNumber === '' || employeeDetails.panNumber === null))
// {
//   setError({ ...error, message: "Please Enter Data ...", status: 500 });
   
// }
// else{
  props.updateEmp(empFormData);
  setError({ ...error, message: "Information updated successfully ...", status: 200 });
    handleClickEdit("");
// }

  }, [employeeDetails]);

  const isValidEmail = (email) => {
  if (!email) return true; // allow empty
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};
  // ------------------------------form personalInfo
  const personalInfoFrom = (
    <Fragment>
      <Form>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Office Mail Id
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              style={inputHeight}
              value={(employeeDetails.primaryMailId === null || employeeDetails.primaryMailId === 'null') ? "" : employeeDetails.primaryMailId}
              onChange={(e) => {
    handleOnChangePersonalInfoFields("primaryMailId", e.target.value);
    if (!isValidEmail(e.target.value)) {
      setError({ ...error, message: "Primary Email is not valid", status: 500 });
    } else {
      setError(null);
    }
  }}  
              
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Alternate Email Id
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.secondaryMailId === null || employeeDetails.secondaryMailId === 'null') ? "" : employeeDetails.secondaryMailId}
             onChange={(e) => {
    handleOnChangePersonalInfoFields("secondaryMailId", e.target.value);
    if (!isValidEmail(e.target.value)) {
      setError({ ...error, message: "secondary Email is not valid", status: 500 });
    } else {
      setError(null);
    }
  }}
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        {/* <FormGroup row>
          <Label sm={4} style={fontSize}>
            Passport No.
          </Label>
          <Col sm={8}>
            <Input type="text" style={inputHeight} />
          </Col>
        </FormGroup> */}
        {/* <FormGroup row>
          <Label sm={4} style={fontSize}>
            Passport Exp Date.
          </Label>
          <Col sm={8}>
            <Input type="text" style={inputHeight} />
          </Col>
        </FormGroup> */}
<FormGroup row>
  <Label sm={4} style={fontSize}>
    Mobile No.
  </Label>
  <Col sm={8}>
    <Input
      type="text"
      value={
        employeeDetails.mobileNumber === null ||
        employeeDetails.mobileNumber === "null"
          ? ""
          : employeeDetails.mobileNumber
      }
      onChange={(e) => {
        const val = e.target.value;
        if (/^\d*$/.test(val)) {
          handleOnChangePersonalInfoFields("mobileNumber", val);
        }
      }}
      style={inputHeight}
    />
  </Col>
</FormGroup>

<FormGroup row>
  <Label sm={4} style={fontSize}>
    Emergency Contact No.
  </Label>
  <Col sm={8}>
    <Input
      type="text"
      value={
        employeeDetails.emergencyNumber === null ||
        employeeDetails.emergencyNumber === "null"
          ? ""
          : employeeDetails.emergencyNumber
      }
      onChange={(e) => {
        const val = e.target.value;
        if (/^\d*$/.test(val)) {
          handleOnChangePersonalInfoFields("emergencyNumber", val);
        }
      }}
      style={inputHeight}
    />
  </Col>
</FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Blood Group
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.bloodGroup === null || employeeDetails.bloodGroup === 'null') ? "" : employeeDetails.bloodGroup}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("bloodGroup", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Date of Birth
          </Label>
          <Col sm={8}>
            <Input
              type="date"
              // value="2018-07-22"
              value={
                employeeDetails?.dateOFBirth =='0001-01-01T00:00:00' ? 'YYYY-MM-DD' : employeeDetails?.dateOFBirth?.substring(0, 10) ?? new Date()
              }
              onChange={(e) =>
                handleOnChangePersonalInfoFields("dateOFBirth", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Father's/Husband's Name
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.guardianName === null || employeeDetails.guardianName === 'null') ? "" : employeeDetails.guardianName}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("guardianName", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Postal Address
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.postalAddress === null || employeeDetails.postalAddress === 'null') ? "" : employeeDetails.postalAddress}
              onChange={(e) =>
                handleOnChangePersonalInfoFields(
                  "postalAddress",
                  e.target.value
                )
              }
              style={inputHeight}
            />
          </Col>
          </FormGroup>
          <FormGroup row>
          <Label sm={4} style={fontSize}>
            Shifts
          </Label>
          <Col sm={8}>
            <Input
              type="select"
              style={inputHeight}
              name="select"
              onChange={(e) =>
                handleOnChangePersonalInfoFields(
                  "shiftId",
                  e.target.value
                )
              }
            >
              <option value="">----Select----</option>
              {shifts.map((quali) => (
                <option
                  key={quali.shiftId}
                  value={quali.shiftId}
                  data-name={quali.shiftName}
                  selected={
                    quali.shiftId === employeeDetails.shiftId ? true : false
                  }
                >
                  {quali.shiftName}
                </option>
              ))}
            </Input>
          
          </Col>
        </FormGroup>
        
        <FormGroup check row className="text-center">
          <Button
            color=""
            className="btn-admin-settings"
            onClick={handleUpdatePersonalInfo}
          >
            Update
          </Button>
          &nbsp;
          <Button
            color=""
            className="btn-cancel"
            onClick={() => handleClickEdit("")}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>
    </Fragment>
  );
  // -------------------------------form bank information.

  const bankInfoForm = loginUser.RoleName == 'Admin' ? (
    
    <Fragment>
      <Form>
        <FormGroup row style={{"display":"none"}}>
          <Label sm={4} style={fontSize}>
            Bank Name
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={employeeDetails.postalAddress}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("bankName", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label sm={4} style={fontSize}>
          Bank account No
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.bankAccountNumber === null || employeeDetails.bankAccountNumber === 'null') ? "" :employeeDetails.bankAccountNumber}
              onChange={(e) =>
                handleOnChangePersonalInfoFields(
                  "bankAccountNumber",
                  e.target.value
                )
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            IFSC Code
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.ifscCode === null || employeeDetails.ifscCode === 'null') ? "" :employeeDetails.ifscCode}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("ifscCode", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
          Aadhar No.
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.aadharNumber === null || employeeDetails.aadharNumber === 'null') ? "" :employeeDetails.aadharNumber}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("aadharNumber", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
          Pan No.
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.panNumber === null || employeeDetails.panNumber === 'null') ? "" : employeeDetails.panNumber}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("panNumber", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
          EPF
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.epfuan === null || employeeDetails.epfuan === 'null') ? "" : employeeDetails.epfuan}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("epfuan", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
          ESI
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.esiNumber === null || employeeDetails.esiNumber === 'null') ? "" : employeeDetails.esiNumber}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("esiNumber", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
          Skype ID
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.skypeID === null || employeeDetails.skypeID === 'null') ? "" : employeeDetails.skypeID}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("skypeID", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup check row className="text-center">
          <Button
            color=""
            className="btn-admin-settings"
            onClick={handleUpdatePersonalInfo}
          >
            Update
          </Button>
          &nbsp;
          <Button
            color=""
            className="btn-cancel"
            onClick={() => handleClickEdit("")}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>
    </Fragment>
  ) : (
    
    <Fragment>
      <Form>
  
        <FormGroup row>
          <Label sm={4} style={fontSize}>
          EPF
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.epfuan === null || employeeDetails.epfuan === 'null') ? "" : employeeDetails.epfuan}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("epfuan", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
          ESI
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.esiNumber === null || employeeDetails.esiNumber === 'null') ? "" : employeeDetails.esiNumber}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("esiNumber", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
          Skype ID
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={(employeeDetails.skypeID === null || employeeDetails.skypeID === 'null') ? "" : employeeDetails.skypeID}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("skypeID", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
        <FormGroup check row className="text-center">
          <Button
            color=""
            className="btn-admin-settings"
            onClick={handleUpdatePersonalInfo}
          >
            Update
          </Button>
          &nbsp;
          <Button
            color=""
            className="btn-cancel"
            onClick={() => handleClickEdit("")}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>
    </Fragment>
  );
  //----------------Educational Information
  const eduInformation = (
    <Fragment>
      <Form>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Qualification Name
          </Label>
          <Col sm={8}>
            <Input
              type="select"
              style={inputHeight}
              name="select"
              onChange={(e) => setQualificationId(e.target.value)}
            >
              <option value="">----Select----</option>
              {qualification.map((quali) => (
                <option
                  key={quali.qualificationId}
                  value={quali.qualificationId}
                  data-name={quali.qualificationName}
                  selected={
                    quali.qualificationId === qualificationId ? true : false
                  }
                >
                  {quali.qualificationName}
                </option>
              ))}
            </Input>
          </Col>
        </FormGroup>
        <FormGroup row>
        <Label sm={4} style={fontSize}>
         Branch
        </Label>
       <Col sm={8}>
        <Input
          type="text"
          style={inputHeight}
            value={branch}
           onChange={(e) => {
            const value = e.target.value;
        // ✅ Allow only alphabets and spaces
            if (/^[A-Za-z\s]*$/.test(value)) {
            setBranch(value);
         }
        }}
      />
      </Col>
    </FormGroup>
       <FormGroup row>
         <Label sm={4} style={fontSize}>
             University
        </Label>
       <Col sm={8}>
       <Input
        type="text"
        style={inputHeight}
        value={university}
         onChange={(e) => {
       const value = e.target.value;
        // ✅ Allow only alphabets and spaces
        if (/^[A-Za-z\s]*$/.test(value)) {
          setUniversity(value);
        }
         }}
       />
      </Col>
    </FormGroup>
       <FormGroup row>
  <Label sm={4} style={fontSize}>
    Year of Passing
  </Label>
  <Col sm={8}>
    <Input
      type="text"
      style={inputHeight}
      value={yop}
      maxLength={4}
      placeholder="YYYY"
      onChange={(e) => {
        const val = e.target.value;
        // Allow only digits
        if (/^\d*$/.test(val)) {
          if (Number(val) <= new Date().getFullYear()) {
            setyop(val);
          } else {
            alert("Year of Passing cannot be in the future");
          }
        } else {
          alert("Only numbers are allowed");
        }
      }}
    />
  </Col>
</FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Type Of Study
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              style={inputHeight}
              value={typeofstudy}
              onChange={(e) => setTypeofstudy(e.target.value)}
            />
          </Col>
        </FormGroup>
    <FormGroup row>
  <Label sm={4} style={fontSize}>
    Percentage(%)/GPA
  </Label>
  <Col sm={8}>
    <Input
      type="text"
      style={inputHeight}
      value={gpa}
      onChange={(e) => {
        const val = e.target.value;
        // Allow only numbers with optional single decimal point
        if (/^\d*\.?\d*$/.test(val)) {
          setgpa(val);
        }
      }}
    />
  </Col>
</FormGroup>
        <FormGroup check row className="text-center">
          <Button
            color=""
            className="btn-admin-settings"
            onClick={handleAddClickEduInfo}
          >
            {qualificationName !== "" ? "Update" : "Add"}
          </Button>
          &nbsp;
          <Button
            color=""
            className="btn-cancel"  
            onClick={() => handleClickEdit("")}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>
    </Fragment>
  );
  //===========================================
  //----------------Work Experience
  const workExperience = (
    <Fragment>
       <Form>
       <FormGroup row>
  <Label sm={4} style={fontSize}>
    Company Name
  </Label>
  <Col sm={8}>
    <Input
      type="text"
      style={inputHeight}
      value={company}
      onChange={(e) => setCompany(e.target.value)}
    />
  </Col>
</FormGroup>

<FormGroup row>
  <Label sm={4} style={fontSize}>
    Designation
  </Label>
  <Col sm={8}>
    <Input
      type="text"
      style={inputHeight}
      value={designation}
      onChange={(e) => setDesignation(e.target.value)}
    />
  </Col>
</FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Duration Of Work
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              style={inputHeight}
              placeholder={"in years"}
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
  <Label sm={4} style={fontSize}>
    From
  </Label>
  <Col sm={8}>
    <Input
      type="date"
      style={inputHeight}
      value={durationFrom}
      onChange={(e) => {
        const fromDate = e.target.value;
        if (durationTo && new Date(fromDate) > new Date(durationTo)) {
          alert("From date cannot be after To date");
          return;
        }
        setFrom(fromDate);
      }}
    />
  </Col>
</FormGroup>

<FormGroup row>
  <Label sm={4} style={fontSize}>
    To
  </Label>
  <Col sm={8}>
    <Input
      type="date"
      style={inputHeight}
      value={durationTo}
      onChange={(e) => {
        const toDate = e.target.value;
        if (durationFrom && new Date(toDate) < new Date(durationFrom)) {
          alert("To date cannot be before From date");
          return;
        }
        setTo(toDate);
      }}
    />
  </Col>
</FormGroup>
        <FormGroup check row className="text-center">
          <Button
            color=""
            className="btn-admin-settings"
            onClick={handleAddClickCompanyInfo}
          >
            {employeeCompanyDetailsId !== 0 ? "Update" : "Add"}
          </Button>
          &nbsp;
          <Button
            color=""
            className="btn-cancel"
            onClick={() => handleClickEdit("")}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>
    </Fragment>
  );
  //===================End of Form ====================
  return (
    <div className="profile-box">
      <Row>
        {/* ------- Personal Information card */}
        <Col md="6">
          <Card className="flex-fill">
            <CardBody>
              <CardTitle>
                <h3>
                  Personal Information
                  {isClickEdit === "personalInfo" ? (
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleClickEdit("")}
                    >
                      <i className="fas fa-times"></i>
                    </span>
                  ) : (
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleClickEdit("personalInfo")}
                    >
                      <i className="fas fa-pencil-alt"></i>
                    </span>
                  )}
                </h3>
              </CardTitle>
              {isClickEdit === "personalInfo" ? (
                personalInfoFrom
              ) : (
                <ul className="personal-info">
                  <li>
                    <div className="title">Office Mail Id</div>
                    <div className="text">{employeeDetails.primaryMailId !== null ? employeeDetails.primaryMailId :"-"}</div>
                  </li>
                  <li>
                    <div className="title">Alternative Mail Id</div>
                    <div className="text">
                      {(employeeDetails.secondaryMailId === 'null' || employeeDetails.secondaryMailId === null) ? "-" : employeeDetails.secondaryMailId}
                    </div>
                  </li>
                  {/* <li>
                    <div className="title">Passport No.</div>
                    <div className="text">9876543210</div>
                  </li>
                  <li>
                    <div className="title">Passport Exp Date.</div>
                    <div className="text">9876543210</div>
                  </li> */}
                  <li>
                    <div className="title">Mobile No.</div>
                    <div className="text">{(employeeDetails.mobileNumber === 'null' || employeeDetails.mobileNumber === null) ? "-" : employeeDetails.mobileNumber}</div>
                  </li>
                  <li>
                    <div className="title">Emergency Contact No.</div>
                    <div className="text">
                      {(employeeDetails.emergencyNumber === 'null' || employeeDetails.secondaryMailId === null) ? "-" : employeeDetails.emergencyNumber}
                    </div>
                  </li>
                  <li>
                    <div className="title">Blood Group</div>
                    <div className="text">{(employeeDetails.bloodGroup === 'null' || employeeDetails.secondaryMailId === null)? "-" :employeeDetails.bloodGroup}</div>
                  </li>
                  <li>
                    <div className="title">Date of Birth</div>
                    <div className="text">
                    {(employeeDetails.dateOFBirth ==='0001-01-01T00:00:00' || employeeDetails.secondaryMailId === null) ? "-" : Moment(employeeDetails.dateOFBirth).format("DD-MM-YYYY") }

                    </div>
                  </li>
                  <li>
                    <div className="title">Father's/Husband's Name</div>
                    <div className="text">{(employeeDetails.guardianName === 'null' || employeeDetails.secondaryMailId === null) ? "-" : employeeDetails.guardianName}</div>
                  </li>
                  <li>
                    <div className="title">Postal Address</div>
                    <div className="text">{(employeeDetails.postalAddress === 'null' || employeeDetails.secondaryMailId === null) ? "-" : employeeDetails.postalAddress}</div>
                  </li>
                  
                  <li>
                  <div className="title">Shift</div>
                  <div className="text">
                    {(employeeDetails.shiftName === null || employeeDetails.secondaryMailId === null) ? "-" : employeeDetails.shiftName}
                   
                   
                   </div>
                  </li>
                   
                </ul>
              )}
            </CardBody>
          </Card>
        </Col>

        {/* ------- Bank Information card */}
        <Col md="6">
          <Card className="flex-fill">
            <CardBody>
              <CardTitle>
                <h3>
                  Bank Information
                  {isClickEdit === "bankInfo" ? (
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleClickEdit("")}
                    >
                      <i className="fas fa-times"></i>
                    </span>
                  ) : (
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleClickEdit("bankInfo")}
                    >
                      <i className="fas fa-pencil-alt"></i>
                    </span>
                  )}
                </h3>
              </CardTitle>
              {isClickEdit === "bankInfo" ? (
                bankInfoForm
              ) : (
                <Fragment>
                  <ul className="personal-info">
                    <li style={{"display":"none"}}>
                      <div className="title">Bank name</div>
                      <div className="text">*ICICI Bank</div>
                    </li>
                    <li>
                      <div className="title">Bank account No.</div>
                      <div className="text">
                        {(employeeDetails.bankAccountNumber === 'null' || employeeDetails.bankAccountNumber === null)? "-" : maskAadhar(employeeDetails.bankAccountNumber)}
                      </div>
                    </li>
                    <li>
                      <div className="title">IFSC Code</div>
                      <div className="text">{(employeeDetails.ifscCode === null || employeeDetails.ifscCode === 'null')? "-" : maskAadhar(employeeDetails.ifscCode)}</div>
                    </li>
                  </ul>
                  <br/>
                  {/* <CardTitle> */}
                    <h5>Aadhar {"&"} Pan </h5>
                    <ul className="personal-info">
                      <li>
                        <div className="title">Aadhar No.</div>
                        <div className="text">
                          {(employeeDetails.aadharNumber === 'null' || employeeDetails.aadharNumber === null)? "-" : maskAadhar(employeeDetails.aadharNumber)}
                        </div>
                      </li>
                      <li>
                        <div className="title">Pan No.</div>
                        <div className="text">{(employeeDetails.panNumber === null || employeeDetails.panNumber === 'null') ? "-" : maskAadhar(employeeDetails.panNumber)}</div>
                      </li>
                    </ul>
                    <br/>
                    <h5>Employee Information </h5>
                    <ul className="personal-info">
                      <li>
                        <div className="title">EPF</div>
                        <div className="text">
                          {(employeeDetails.epfuan === 'null' || employeeDetails.epfuan === null)? "-" : employeeDetails.epfuan}
                        </div>
                      </li>
                      <li>
                        <div className="title">ESI</div>
                        <div className="text">{(employeeDetails.esiNumber === null || employeeDetails.esiNumber === 'null') ? "-" : employeeDetails.esiNumber}</div>
                      </li>
                      <li>
                        <div className="title">Skype Id</div>
                        <div className="text">{(employeeDetails.skypeID === null || employeeDetails.skypeID === 'null') ? "-" : employeeDetails.skypeID}</div>
                      </li>
                    </ul>
                  {/* </CardTitle> */}
                </Fragment>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/*------------Educational information */}
      <Row>
        <Col md="6">
          <Card className="flex-fill">
            <CardBody>
              <CardTitle>
                <h3>
                  Educational Information
                  {isClickEdit === "eduInformation" ? (
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleClickEdit("")}
                    >
                      <i className="fas fa-times"></i>
                    </span>
                  ) : (
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleClearValues("eduInformation")}
                    >
                      <i className="fa fa-plus"></i>
                    </span>
                  )}
                </h3>
              </CardTitle>
              {isClickEdit === "eduInformation" ? (
                eduInformation
              ) : (
                <div className="experience-box">
                  <ul className="experience-list">
                    {props.educationalInfo.map((ed,i) => (
                      <li key={i}>
                        <div className="experience-user">
                          <div className="before-circle"></div>
                        </div>
                        <div className="experience-content">
                          <div className="timeline-content">
                            <a href="#/" className="name">
                              {ed.universityName === null ? "" : ed.universityName}
                            </a>
                            <div>{ed.qualificationName + " " + (ed.branch === null ? "" :ed.branch)}</div>
                            <span className="time">
                              {ed.yearOfPassing !== 0 ? ed.yearOfPassing : ""}
                            </span>
                          </div>
                          <div className="edit-del-icon ">
                            <span
                              className="edit"
                              onClick={() => handleClickUpdateEduInfo(ed)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </span>
                            <span
                              className="del"
                              onClick={() =>
                                handleClickDeleteInfo(
                                  ed.educationalQualificationId,ed.employeeId,1
                                )
                              }
                            >
                              <i className="fas fa-trash"></i>
                            </span>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>

        {/* ----------Work Experience   */}
        <Col md="6">
          <Card className="flex-fill">
            <CardBody>
              <CardTitle>
                <h3>
                  Experience
                  {isClickEdit === "workExperience" ? (
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleClickEdit("")}
                    >
                      <i className="fas fa-times"></i>
                    </span>
                  ) : (
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleClearValues("workExperience")}
                    >
                      <i className="fa fa-plus"></i>
                    </span>
                  )}
                </h3>
              </CardTitle>
              {isClickEdit === "workExperience" ? (
                workExperience
              ) : (
                <div className="experience-box">
                  <ul className="experience-list">
                    {prevcompanyDetails.map((we,i) => (
                      <li key={i}>
                        <div className="experience-user">
                          <div className="before-circle"></div>
                        </div>
                        <div className="experience-content">
                          <div className="timeline-content">
                            <a href="#/" className="name">
                              {we.designation + " at " + we.companyName}
                            </a>
                            <span className="time">
                              {Moment(we.fromDate).format("MMM YYYY") + "-" +Moment(we.toDate).format("MMM YYYY")}
                            </span>
                          </div>
                          <span> </span>
                          <div className="edit-del-icon ">
                            <span
                              className="edit"
                              onClick={() => handleClickUpdateCompanyInfo(we)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </span>
                            <span
                              className="del"
                              onClick={() =>
                                handleClickDeleteInfo(
                                  we.employeeCompanyDetailsId,we.employeeId,2
                                )
                              }
                            >
                              <i className="fas fa-trash"></i>
                            </span>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Notifications notifications={error}></Notifications>
        {isopenpopup == true ? (<PopUp 
    
    hadleDelWithPopYes={hadleDelWithPopYes}
    hadleDelWithPopNo={hadleDelWithPopNo}
    >

</PopUp>) : null}        
{isopenpopupSuccess == true ? (<PopUpSuccess 
    hadleSuccessPop={hadleSuccessPop}
    >

</PopUpSuccess>) : null}
    </div>
  );
});

const mapStateToProps = (state) => ({
  empeducationalInfo: state.empReducer,
});

export default connect(mapStateToProps, {
  getQualification,
  addEmpEducationalInfo,
  updateEmpEducationalInfo,
  delEmpEducationalInfo,
  getEmpPreviousCompanyInfo,
  addPreviousCompanyInfo,
  updatePreviousCompanyInfo,
  delPreviousCompanyInfo,
  updateEmp,
  getEmpEducationalInfo,
  getShifts,
})(TabProfile);
